(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["leafsock-back-to-top"] && !Shopify.designMode) return;
  try {
    (() => {
    const button = document.querySelector('[data-leafsock-back-to-top]');

    if (!button || button.dataset.initialized === 'true') return;

    button.dataset.initialized = 'true';
    let ticking = false;

    const updateVisibility = () => {
      const root = document.documentElement;
      const maximumScroll = Math.max(0, root.scrollHeight - window.innerHeight);
      const threshold = Math.min(480, maximumScroll * 0.5);
      button.hidden = maximumScroll < 160 || window.scrollY < threshold;
    };

    const queueVisibilityUpdate = () => {
      if (ticking) return;

      ticking = true;
      window.requestAnimationFrame(() => {
        updateVisibility();
        ticking = false;
      });
    };

    button.addEventListener('click', () => {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });

    window.addEventListener('scroll', queueVisibilityUpdate, { passive: true });
    window.addEventListener('resize', queueVisibilityUpdate, { passive: true });
    updateVisibility();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["leafsock-cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    const drawer = document.querySelector('[data-leafsock-cart-drawer]');
    if (!drawer || drawer.dataset.initialized === 'true') return;
    drawer.dataset.initialized = 'true';

    const content = drawer.querySelector('[data-ls-cart-content]');
    const footer = drawer.querySelector('[data-ls-cart-footer]');
    const summary = drawer.querySelector('[data-ls-cart-summary]');
    const title = drawer.querySelector('[data-ls-cart-title]');
    const status = drawer.querySelector('[data-ls-cart-status]');
    const cartUrl = drawer.dataset.cartUrl;
    const cartJsonUrl = `${cartUrl}.js`;
    const cartPath = new URL(cartUrl, window.location.origin).pathname.replace(/\/$/, '');
    const cartAddPath = new URL(drawer.dataset.cartAddUrl, window.location.origin).pathname.replace(/\.js$/, '').replace(/\/$/, '');
    const upsellVariantId = Number(drawer.dataset.upsellVariantId || 0);
    let returnFocus = null;
    let closingTimer = null;

    const escapeHtml = value => String(value ?? '').replace(/[&<>"']/g, character => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    })[character]);

    const money = (amount, currency) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: currency || window.Shopify?.currency?.active || 'USD'
        }).format(Number(amount || 0) / 100);
      } catch (error) {
        return `$${(Number(amount || 0) / 100).toFixed(2)}`;
      }
    };

    const announce = message => {
      status.textContent = '';
      window.requestAnimationFrame(() => { status.textContent = message; });
    };

    const setBusy = busy => {
      drawer.classList.toggle('is-busy', busy);
      drawer.setAttribute('aria-busy', String(busy));
    };

    const publicProperties = properties => Object.entries(properties || {}).filter(([name, value]) => name.charAt(0) !== '_' && value);

    const itemDiscounts = item => {
      const allocations = item.line_level_discount_allocations || [];
      return allocations.map(allocation => allocation.discount_application?.title).filter(Boolean);
    };

    const renderItem = (item, currency) => {
      const options = (item.options_with_values || [])
        .filter(option => option.value && option.value !== 'Default Title')
        .map(option => `${escapeHtml(option.name)}: ${escapeHtml(option.value)}`)
        .join(' · ');
      const properties = publicProperties(item.properties)
        .map(([name, value]) => `<p class="ls-cart-drawer__property">${escapeHtml(name)}: ${escapeHtml(value)}</p>`)
        .join('');
      const discounts = itemDiscounts(item)
        .map(discount => `<span class="ls-cart-drawer__discount">${escapeHtml(discount)}</span>`)
        .join('');
      const comparePrice = item.original_line_price > item.final_line_price
        ? `<s>${money(item.original_line_price, currency)}</s>`
        : '';
      const image = item.image
        ? `<a class="ls-cart-drawer__media" href="${escapeHtml(item.url)}"><img src="${escapeHtml(item.image)}" width="184" height="184" alt="${escapeHtml(item.product_title)}"></a>`
        : '<span class="ls-cart-drawer__media"></span>';

      return `<article class="ls-cart-drawer__item" data-ls-cart-item data-key="${escapeHtml(item.key)}">
        ${image}
        <div>
          <div class="ls-cart-drawer__item-head">
            <a class="ls-cart-drawer__item-title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
            <button class="ls-cart-drawer__remove" type="button" data-ls-cart-remove aria-label="${escapeHtml(drawer.dataset.removeLabel)}">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M7 7l1 13h8l1-13M10 11v5M14 11v5" /></svg>
            </button>
          </div>
          ${options ? `<p class="ls-cart-drawer__meta">${options}</p>` : ''}
          ${properties}
          <div class="ls-cart-drawer__item-bottom">
            <div class="ls-cart-drawer__quantity">
              <button type="button" data-ls-cart-quantity="${Math.max(0, item.quantity - 1)}" aria-label="${escapeHtml(drawer.dataset.decreaseLabel)}">−</button>
              <output aria-label="Quantity">${item.quantity}</output>
              <button type="button" data-ls-cart-quantity="${item.quantity + 1}" aria-label="${escapeHtml(drawer.dataset.increaseLabel)}">+</button>
            </div>
            <div>
              <div class="ls-cart-drawer__price">${comparePrice}<strong>${money(item.final_line_price, currency)}</strong></div>
              ${discounts}
            </div>
          </div>
        </div>
      </article>`;
    };

    const renderUpsell = (cart, currency) => {
      if (!upsellVariantId || drawer.dataset.upsellAvailable !== 'true') return '';
      if (cart.items.some(item => Number(item.variant_id) === upsellVariantId)) return '';
      const price = Number(drawer.dataset.upsellPrice || 0);
      const comparePrice = Number(drawer.dataset.upsellComparePrice || 0);
      const image = drawer.dataset.upsellImage
        ? `<a class="ls-cart-drawer__upsell-media" href="${escapeHtml(drawer.dataset.upsellUrl)}"><img src="${escapeHtml(drawer.dataset.upsellImage)}" width="184" height="184" alt="${escapeHtml(drawer.dataset.upsellTitle)}"></a>`
        : '<span class="ls-cart-drawer__upsell-media"></span>';

      return `<section class="ls-cart-drawer__upsell" aria-labelledby="LeafSockCartUpsellTitle">
        <h3 id="LeafSockCartUpsellTitle">${escapeHtml(drawer.dataset.upsellHeading)}</h3>
        <div class="ls-cart-drawer__upsell-card">
          ${image}
          <div>
            <a class="ls-cart-drawer__upsell-title" href="${escapeHtml(drawer.dataset.upsellUrl)}">${escapeHtml(drawer.dataset.upsellTitle)}</a>
            <div class="ls-cart-drawer__upsell-price">${comparePrice > price ? `<s>${money(comparePrice, currency)}</s>` : ''}<strong>${money(price, currency)}</strong></div>
            <button class="ls-cart-drawer__upsell-button" type="button" data-ls-cart-upsell>${escapeHtml(drawer.dataset.upsellButtonLabel)}</button>
          </div>
        </div>
      </section>`;
    };

    const updateCartLinks = cart => {
      document.querySelectorAll('a[href]').forEach(link => {
        let path;
        try { path = new URL(link.href, window.location.origin).pathname.replace(/\/$/, ''); } catch (error) { return; }
        if (path !== cartPath) return;
        link.setAttribute('aria-label', `${drawer.dataset.cartLabel}, ${cart.item_count}`);
        if (/^cart\s*(\(\d+\))?$/i.test(link.textContent.trim())) link.textContent = `${drawer.dataset.cartLabel} (${cart.item_count})`;
      });
      const legacyCount = document.getElementById('CartCount');
      if (legacyCount) {
        legacyCount.textContent = cart.item_count;
        legacyCount.closest('.header__cart-count')?.classList.toggle('hidden-count', cart.item_count === 0);
      }
    };

    const renderCart = cart => {
      const currency = cart.currency || window.Shopify?.currency?.active || 'USD';
      title.textContent = drawer.dataset.titleTemplate.replace('__COUNT__', cart.item_count);
      updateCartLinks(cart);

      if (!cart.item_count) {
        content.innerHTML = `<div class="ls-cart-drawer__empty">
          <svg viewBox="0 0 48 48" aria-hidden="true"><path d="M13 16h22l-2 23H15l-2-23Zm6 0v-3a5 5 0 0 1 10 0v3" /></svg>
          <h3>${escapeHtml(drawer.dataset.emptyTitle)}</h3>
          <p>${escapeHtml(drawer.dataset.emptyCopy)}</p>
          <button type="button" data-ls-cart-close>${escapeHtml(drawer.dataset.continueLabel)}</button>
        </div>`;
        footer.hidden = true;
      } else {
        content.innerHTML = `${cart.items.map(item => renderItem(item, currency)).join('')}${renderUpsell(cart, currency)}`;
        summary.innerHTML = `${cart.total_discount > 0 ? `<div class="ls-cart-drawer__summary-row ls-cart-drawer__summary-row--discount"><span>${escapeHtml(drawer.dataset.discountsLabel)}</span><strong>−${money(cart.total_discount, currency)}</strong></div>` : ''}
          <div class="ls-cart-drawer__summary-row ls-cart-drawer__summary-row--total"><span>${escapeHtml(drawer.dataset.totalLabel)}</span><strong>${money(cart.total_price, currency)}</strong></div>`;
        footer.hidden = false;
      }

      window.dispatchEvent(new CustomEvent('leafsock:cart:updated', { detail: { cart } }));
      return cart;
    };

    const fetchCart = async () => {
      const response = await fetch(cartJsonUrl, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (!response.ok) throw new Error(drawer.dataset.errorLabel);
      return renderCart(await response.json());
    };

    const openDrawer = async trigger => {
      window.clearTimeout(closingTimer);
      returnFocus = trigger instanceof HTMLElement ? trigger : document.activeElement;
      if (!drawer.open) drawer.showModal();
      document.body.classList.add('ls-cart-drawer-open');
      window.requestAnimationFrame(() => drawer.classList.add('is-open'));
      setBusy(true);
      content.innerHTML = `<div class="ls-cart-drawer__loading">${escapeHtml(drawer.dataset.loadingLabel)}</div>`;
      try {
        await fetchCart();
        drawer.querySelector('[data-ls-cart-close]')?.focus();
      } catch (error) {
        content.innerHTML = `<div class="ls-cart-drawer__empty"><h3>${escapeHtml(drawer.dataset.errorLabel)}</h3></div>`;
        announce(drawer.dataset.errorLabel);
      } finally {
        setBusy(false);
      }
    };

    const closeDrawer = () => {
      if (!drawer.open) return;
      drawer.classList.remove('is-open');
      document.body.classList.remove('ls-cart-drawer-open');
      closingTimer = window.setTimeout(() => {
        drawer.close();
        if (returnFocus instanceof HTMLElement) returnFocus.focus();
      }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 240);
    };

    const changeItem = async (key, quantity) => {
      setBusy(true);
      try {
        const response = await fetch(drawer.dataset.cartChangeUrl, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: key, quantity })
        });
        const cart = await response.json();
        if (!response.ok) throw new Error(cart.description || drawer.dataset.errorLabel);
        renderCart(cart);
        announce(quantity === 0 ? drawer.dataset.removeLabel : `${drawer.dataset.cartLabel}: ${cart.item_count}`);
      } catch (error) {
        announce(error.message || drawer.dataset.errorLabel);
      } finally {
        setBusy(false);
      }
    };

    const addUpsell = async () => {
      if (!upsellVariantId) return;
      setBusy(true);
      try {
        const response = await fetch(drawer.dataset.cartAddUrl, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: upsellVariantId, quantity: 1 }] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || drawer.dataset.errorLabel);
        await fetchCart();
        announce(drawer.dataset.upsellAddedLabel);
      } catch (error) {
        announce(error.message || drawer.dataset.errorLabel);
      } finally {
        setBusy(false);
      }
    };

    drawer.addEventListener('click', event => {
      if (event.target === drawer || event.target.closest('[data-ls-cart-close]')) {
        closeDrawer();
        return;
      }
      if (event.target.closest('[data-ls-cart-upsell]')) {
        addUpsell();
        return;
      }
      const item = event.target.closest('[data-ls-cart-item]');
      if (!item) return;
      if (event.target.closest('[data-ls-cart-remove]')) changeItem(item.dataset.key, 0);
      const quantityButton = event.target.closest('[data-ls-cart-quantity]');
      if (quantityButton) changeItem(item.dataset.key, Number(quantityButton.dataset.lsCartQuantity));
    });

    drawer.addEventListener('cancel', event => {
      event.preventDefault();
      closeDrawer();
    });

    document.addEventListener('click', event => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[href]');
      if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
      let path;
      try { path = new URL(link.href, window.location.origin).pathname.replace(/\/$/, ''); } catch (error) { return; }
      if (path !== cartPath || window.location.pathname.replace(/\/$/, '') === cartPath) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      openDrawer(link);
    }, true);

    document.addEventListener('submit', async event => {
      const form = event.target.closest('form[action]');
      if (!form || form.matches('[data-ls-bundle-form], [data-leafsock-originals-form]')) return;
      let action;
      try { action = new URL(form.action, window.location.origin); } catch (error) { return; }
      if (action.pathname.replace(/\.js$/, '').replace(/\/$/, '') !== cartAddPath) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const submitter = event.submitter || form.querySelector('[type="submit"]');
      const previousText = submitter?.textContent;
      if (submitter) submitter.disabled = true;
      try {
        const formData = new FormData(form);
        formData.delete('return_to');
        const response = await fetch(drawer.dataset.cartAddUrl, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          body: formData
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || drawer.dataset.errorLabel);
        await openDrawer(submitter);
      } catch (error) {
        announce(error.message || drawer.dataset.errorLabel);
      } finally {
        if (submitter) {
          submitter.disabled = false;
          if (previousText) submitter.textContent = previousText;
        }
      }
    }, true);

    window.addEventListener('leafsock:cart:open', event => openDrawer(event.detail?.trigger));
    window.LeafSockCartDrawer = { open: openDrawer, close: closeDrawer, refresh: fetchCart };
  })();
  } catch(e) { console.error(e); }
})();

})();
